"use client"
import React, { useEffect, useRef } from "react";
import { useIframe } from "./useIframe";

const IframeComponent: React.FC = () => {
  const {
    showIframe,
    isLoaded,
    scale,
    progress,
    showProgress,
    handleIframeLoad,
    handleClose,
    isClosing,
  } = useIframe();

  const containerRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     if (
  //       containerRef.current &&
  //       !containerRef.current.contains(event.target as Node)
  //     ) {
  //       handleClose();
  //     }
  //   };

  //   if (showIframe) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [showIframe, handleClose]);

  useEffect(() => {
    if (showIframe) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showIframe]);

  if (!showIframe) return null;

  return (
    <div
      className={`fixed ${
        showProgress ? "" : "bg-black backdrop-blur-sm"
      } w-full inset-x-0 min-h-screen bg-opacity-50 flex items-center justify-center z-50`}
    >
      <div ref={containerRef} className="relative w-[90%] xl:max-w-[1600px]">
        {/* Progress Bar */}
        {showProgress && (
          <div className="bg-white/50 rounded-lg h-[20px] transition-all duration-300 ease-in-out">
            <div className="w-full h-full flex items-center justify-center px-4">
              <div className="w-full bg-gray-200 rounded-full h-1.5">
                <div
                  className="bg-[#5ec3ef] h-1.5 rounded-full transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Iframe Container */}
        <div
          className={`bg-white rounded-lg transition-all duration-500 ease-in-out ${
            isLoaded || isClosing ? "h-[80vh] md:h-[90vh]" : "h-0"
          }`}
          style={{
            opacity: isLoaded ? 1 : 0,
            transform: `translateY(${isLoaded || isClosing ? "0" : "20px"}) scaleY(${scale})`,
            transformOrigin: "center",
            transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
          }}
        >
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute -top-4 -right-3 bg-black text-white p-2 rounded-full hover:bg-red-600 transition-colors w-[35px] h-[35px]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-5 -ml-[1px] -mt-[1px]"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Iframe */}
          <iframe
            src="https://aichat.chatoshi.ai/"
            className="w-full h-full border-2 border-gray-300 rounded-lg"
            title="Hero Website"
            onLoad={handleIframeLoad}
          />
        </div>
      </div>
    </div>
  );
};

export default IframeComponent;
